import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { RdsChipsModule } from '../chips/index';
import { RdsTextFiltersToChipsPipe } from './text-filter-chips.pipe';
import { RdsTextFilterComponent } from './text-filter.component';

const COMPONENTS = [RdsTextFilterComponent];
const PIPES = [RdsTextFiltersToChipsPipe];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    ReactiveFormsModule,
    RdsChipsModule
  ],
  exports: [COMPONENTS],
  declarations: [COMPONENTS, PIPES]
})
export class RdsTextFilterModule {}

export * from './text-filter.component';
export * from './text-filter.model';
